module.exports = __webpack_public_path__ + "img/life.413b382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img/life.png
// module id = Ff4g
// module chunks = 0